export default __webpack_public_path__ + "static/media/close-issue-icon.18cb3c32.svg";